import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  ref: "modalRef",
  class: "modal-content neon"
}
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "text" }
const _hoisted_4 = { class: "actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_button = _resolveComponent("app-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _createElementVNode("span", null, _toDisplayString(_ctx.title), 1)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("span", null, _toDisplayString(_ctx.text), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", {
        class: "btn",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
      }, [
        _createVNode(_component_app_button, {
          title: "cancel",
          severity: "error"
        })
      ]),
      _createElementVNode("div", {
        class: "btn",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.ok && _ctx.ok(...args)))
      }, [
        _createVNode(_component_app_button, {
          title: "ok",
          severity: "info"
        })
      ])
    ])
  ], 512))
}